// src/com/trans_plan_bind_store/TransPlanBindStoreDict.js
import { TableColumnType } from "../../value/AppConst";

// 운송요청 동적 배차내역, trans_plan_bind_store
const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    bindGroupNo : {
		id: 'bindGroupNo', required: true, toAdd: true, toEdit: true,
	}, // int(11)
    planId : {
		id: 'planId', required: true, toAdd: true, toEdit: true,
	}, // varchar(12)
    planIdAnchor : {
		id: 'planIdAnchor', required: true, toAdd: false, toEdit: true,
	}, // varchar(12)
    front : {
		id: 'front', required: false, toAdd: true, toEdit: true,
	},
};

/**
 * TRANS_PLAN_BIND_STORE React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2025-02-25 14:33:09 using DbdbTap
 * https://www.dbdbtap.com
 */
export const TransPlanBindStoreDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '동적 추가 오류',
        Edit: '동적 순서 변경 오류',
        Remove: '동적에서 제외 오류',
        Get: '동적데이터 조회 오류',
    },
    tableProps: {
        tableId: 'transPlanBindStoreTable', // 동적에 해당하지 않는 점포들의 테이블에 사용함.
        uniqueKey: 'planId',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: true,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            { id: 'storeName', label: '점포', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'storeId', label: '점포코드', width: 64, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'hocha', label: '호차', width: 60, show: true, option:{align: 'center', print:(r,i,v)=>`${v}호차`} },
            { id: 'vehPlates', label: '차량', width: 110, show: true, option:{align: 'inherit', print:(r,i,v)=>v?v:'미정'} },
            { id: 'comName', label: '운송사', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dptrReqTime', label: '출발요청', width: 70, show: true, option:{align: 'center', print:(r,i,v)=>v?v.substring(11,16):'-'} },
            //{ id: 'planId', label: 'ID', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
};
